import React from "react";

function CurrentBreadcrumb({ title }) {
  return (
    <div className="inline text-nimbus font-bold text-lg ml-2">{title}</div>
  );
}

export default CurrentBreadcrumb;
